import ViewPhoto from './ViewPhoto'

export default ViewPhoto
